import React from 'react';
import PropTypes from 'prop-types';
import withHandlers from 'recompose/withHandlers';
import FormGroup from '@spothero/ui/form-group';
import Label from '@spothero/ui/label';
import Radio from '@spothero/ui/radio';
import RadioGroup from '@spothero/ui/radio-group';

const AvailableReservations = ({
    updateMonthlyStarts,
    monthlyStarts,
    invoiceStartDate,
    invoiceNextStartDate,
    invoiceStartDateFormatted,
    invoiceEndDateFormatted,
    invoiceNextStartDateFormatted,
    invoiceNextEndDateFormatted
}) => {
    const items = [
        {
            label: `${invoiceStartDateFormatted} - ${invoiceEndDateFormatted}`,
            value: invoiceStartDate,
            checked: (monthlyStarts !== invoiceNextStartDate.split('T')[0])
        },
        {
            label: `${invoiceNextStartDateFormatted} - ${invoiceNextEndDateFormatted}`,
            value: invoiceNextStartDate,
            checked: (monthlyStarts === invoiceNextStartDate.split('T')[0])
        }
    ];

    return (
        <div className="AvailableReservations">
            <FormGroup>
                <RadioGroup
                    id="AvailableReservations-monthly-start-date"
                    name="monthlyStartDate"
                    onChange={updateMonthlyStarts}
                >
                    {items.map((item, i) => {
                        return (
                            <Radio
                                key={i}
                                label={<Label>{item.label}</Label>}
                                value={item.value}
                                defaultChecked={item.checked}
                            />
                        );
                    })}
                </RadioGroup>
            </FormGroup>
        </div>
    );
};

AvailableReservations.propTypes = {
    updateMonthlyStarts: PropTypes.func.isRequired,
    monthlyStarts: PropTypes.string.isRequired,
    invoiceStartDate: PropTypes.string.isRequired,
    invoiceNextStartDate: PropTypes.string.isRequired,
    invoiceStartDateFormatted: PropTypes.string.isRequired,
    invoiceEndDateFormatted: PropTypes.string.isRequired,
    invoiceNextStartDateFormatted: PropTypes.string.isRequired,
    invoiceNextEndDateFormatted: PropTypes.string.isRequired
};

export default withHandlers({
    updateMonthlyStarts: props => evt => {
        props.updateMonthlyStarts({
            starts: evt.target.value,
            ends: null
        });
    }
})(AvailableReservations);
